import styled from 'styled-components';
import { OverlineFont } from '../../../../../../themes/fonts';
import { THEME } from '../../../../../../themes';
import { ASSETS } from '../../../../../../assets';

export const Container = styled.div`
  ${OverlineFont};
  cursor: pointer;
  color: ${THEME.COLORS.PRIMARY_DARK};
  width: fit-content;
  margin-top: ${THEME.SPACING.BASE};
  display: flex;
  align-items: center;
  gap: ${THEME.SPACING.TINY};
`;

export const ButtonIcon = styled(ASSETS.ARROW_DOWN)`
  width: 12px;
  height: 12px;
  fill: ${THEME.COLORS.PURE_WHITE};
  background-color: ${THEME.COLORS.PRIMARY_DARK};
  border-radius: ${THEME.RADIUS.CIRCLE};
`;
